import vButton from "./v-button.vue";

export default Vue => {
  Vue.component("v-button", vButton);
};
